







































































import { Component, Vue } from "vue-property-decorator";
import router from "@/router";
import { BrokenRule } from "@/shared/models/apiErrors";

export class LoginModel {
  username = "";
  password = "";
}

@Component
export default class Signin extends Vue {
  model = new LoginModel();

  isFormValid = false;
  isSubmitting = false;
  showPassword = false;

  showErrors = false;
  errors: string[] = [];

  get submitDisabled(): boolean {
    return this.isFormValid && !this.isSubmitting;
  }

  get rules() {
    return {
      required: (value: string) => !!value || this.$t("Validation.Required"),
    };
  }

  async signin(): Promise<void> {
    this.isSubmitting = true;

    const signin = await this.$store.dispatch(
      "auth/checkIfFirstSignin",
      this.model
    );

    if (signin.isSignedIn) {
      await router.replace({ name: "Dashboard" });
    } else {
      this.errors = signin.errors.map((x: BrokenRule) => x.name);
      if (this.errors.length > 0) {
        this.showErrors = true;
      }
    }

    this.isSubmitting = false;
  }
}
